import {
	validatePassword,
	validateConfirmPassword,
	validateUsername,
	validateEmail,
	validateFirstName,
	validateLastName,
	validateMobile,
} from '../validations/auth';
import { getValidationResult } from '../validations/index';

export const getServerErrorsObject = (serverErrors) => {
	let errorsObject = {};
	if(serverErrors.Message){
		errorsObject = { ...errorsObject, message: serverErrors.Message };
	}else if(serverErrors.errors){
		console.log(serverErrors.errors);
		Object.keys(serverErrors.errors).forEach((key) => {
			const message = serverErrors.errors[key][0];
			console.log(key);
			if (key.toLowerCase().includes('username')) {
				errorsObject = { ...errorsObject, username: message };
			} else if (key.toLowerCase().includes('password')) {
				errorsObject = { ...errorsObject, password: message };
			} else if (key.toLowerCase().includes('email')) {
				errorsObject = { ...errorsObject, Email: message };
			} else if (key.toLowerCase().includes('firstname')) {
				errorsObject = { ...errorsObject, firstName: message };
			}else if (key.toLowerCase().includes('lastname')) {
				errorsObject = { ...errorsObject, lastName: message };
			}else if (key.toLowerCase().includes('captchainputtext')) {
				errorsObject = { ...errorsObject, captchaInputText: message };
			}

			
		});
	}else{
		Object.keys(serverErrors).forEach((key) => {
			const message = serverErrors[key][0];
			
			if (message.toLowerCase().includes('username')) {
				errorsObject = { ...errorsObject, username: message };
			} else if (message.toLowerCase().includes('password')) {
				errorsObject = { ...errorsObject, password: message };
			} else if (message.toLowerCase().includes('Email')) {
				errorsObject = { ...errorsObject, Email: message };
			}
		});
	}

	return errorsObject;
};

export const getEmptyInputsErrorsObject = (inputsObject) => {
	let errorsObject = {};
	Object.keys(inputsObject).forEach((key) => {
		const value = inputsObject[key];
		if (!value) {
			
			console.log("getEmptyInputsErrorsObject",key,value);
			
			if (key === 'username') {
				const { error } = validateUsername({ value });
				errorsObject = { ...errorsObject, username: error };
			} else if (key === 'password') {
				const { error } = validatePassword({ value });
				errorsObject = { ...errorsObject, password: error };
			} else if (key === 'firstName') {
				const { error } = validateFirstName({ value });
				errorsObject = { ...errorsObject, firstName: error };
			} else if (key === 'lastName') {
				const { error } = validateLastName({ value });
				errorsObject = { ...errorsObject, lastName: error };
			} else if (key === 'Email') {
				const { error } = validateEmail({ value });
				errorsObject = { ...errorsObject, Email: error };
			} else if (key === 'Mobile') {
				const { error } = validateMobile({ value });
				errorsObject = { ...errorsObject, Mobile: error };
			} else if (key === 'captchaInputText') {
				if(parseInt(value) === NaN || !value){
					console.log(key, value);
					const { error } = {
						isValid: false,
						error: 'این فیلد اجباری می باشد'
					};
					errorsObject = { ...errorsObject, captchaInputText: error };
				}
			} else if(key === 'confirmPassword') {
				const { error } = validateConfirmPassword({ value });
				errorsObject = { ...errorsObject, confirmPassword: error };
			} else if(key === 'message') {
				console.log("step1");
				const { error } = getValidationResult(false,'');
				console.log("step2");
				errorsObject = { ...errorsObject, message: error };
				console.log("step3");
			}
		}
	});
	return errorsObject;
};
